import makeBreadcrumbs from "../../shared/containers/make_breadcrumbs";

import { crumbOverviewClick, crumbRegulationDetailClick } from "../actions/focus_view";

const segmentDefinitions = [
  ["overview", crumbOverviewClick, false],
  ["regulationDetail", crumbRegulationDetailClick, true]
];

export default makeBreadcrumbs(segmentDefinitions);
